export const CANVAS_SIZE = 320
export const CANVAS_SIZE_PORTRAIT_LAYOUT = 510
export const CANVAS_SIZE_MAX_TABLET = 720

export const MOBILE_WIDTH = 350
export const MOBILE_WIDTH_LARGE = 445
export const CONTAINER_MAX_WIDTH = 800
export const TABLET_WIDTH_LARGE = 1024

export const DRAWING_CONTAINER_PADDING = 30

export const CONTINUOUS_USERFLOW = 'continuous'

/**
 * These properties are constant for all cavnas objects.
 * We extract them from the canvas objects prior to sending them object to firebase.
 * We then rehydrate the objects with this data prior to lading into cavnas.
 * This helps to make the canvas object smaller and therefore lowers bandwidth use per request.
 * With millions of strokes, every byte counts.
 */
export const canvasObjConstantProperties = {
  angle: 0,
  backgroundColor: '',
  fill: null,
  fillRule: 'nonzero',
  flipX: false,
  flipY: false,
  globalCompositeOperation: 'source-over',
  opacity: 1,
  originX: 'left',
  originY: 'top',
  paintFirst: 'fill',
  scaleX: 1,
  scaleY: 1,
  skewX: 0,
  skewY: 0,
  strokeDashOffset: 0,
  strokeLineCap: 'round',
  strokeLineJoin: 'round',
  strokeMiterLimit: 10,
  type: 'path',
  version: '2.7.0',
  visible: true,
}



// WEBPACK FOOTER //
// ./src/constants/index.js